export default "__VITE_ASSET__wKfEWUzJ__"